import {
  TradeAreaClient,
  DemoClient,
  FootfallClient,
  GeoClient,
  PerformanceClient,
  VenueClient,
  DevClient,
  PlacesClient,
} from '..'
import { ClientOptions, Clients } from 'src/common-services/types/client-types'
import { ConsumerSpendClient } from 'src/common-services/clients/consumer-spend-client'
import { DriveTimeClient } from 'src/common-services/clients/drive-time-client'
import { UserClient } from 'src/common-services/clients/user-client'
import { CrossVisitClient } from 'src/common-services/clients/cross-visit-client'
import { UserListsClient } from 'src/common-services/clients/user-lists-client'
import { LoggingClient } from 'src/common-services/clients/logging-client'
import { FoursquareClient } from 'src/common-services/clients/foursquare-client'
import { initializeVendors } from 'src/common-services/clients/vendors'
import { SystemClient } from 'src/common-services/clients/system-client'
import { MockDataClient } from 'src/common-services/clients/mock-data-client'
import { TrafficClient } from 'src/common-services/clients/traffic-client'
import { DocumentClient } from 'src/common-services/clients/document-client'
import { UserFilesClient } from 'src/common-services/clients/user-files-client'
import { BrandLogosClient } from 'src/common-services/clients/brand-logos-client'
import { RecentlyViewedClient } from 'src/common-services/clients/recently-viewed-client'
import { ReportThemesClient } from 'src/common-services/clients/report-themes-client'
import { CustomInsightsClient } from 'src/common-services/clients/custom-insights-client'
import { CustomFootfallClient } from 'src/common-services/clients/custom-footfall-client'
import { CompanyClient } from 'src/common-services/clients/company-client'
import { AssetClient } from 'src/common-services/clients/asset-client'
import { SignUpRequestClient } from 'src/common-services/clients/signup-request-client'
import { CompsClient } from 'src/common-services/clients/comps-client'
import { ZoneClient } from 'src/common-services/clients/zone-client'
import { PricingCalculatorClient } from 'src/common-services/clients/pricing-calculator-client'
import { LocalBusinessesClient } from 'src/common-services/clients/local-businesses-client'
import { MobileClient } from 'src/common-services/clients/mobile-client'
import { TenantFinderClient } from 'src/common-services/clients/tenant-finder-client'
import { OkClient } from 'src/common-services/clients/ok-client'
import { OlvinClient } from 'src/common-services/clients/olvin-client'
import { ParcelsClient } from 'src/common-services/clients/parcels-client'
import { CensusClient } from 'src/common-services/clients/census-client'
import { initializeAlphamap } from 'src/common-services/clients/alphamap'
import { PartnersClient } from 'src/common-services/clients/partners-client'
import { BrandsClient } from 'src/common-services/clients/brands-client'
import { CustomMapClient } from 'src/common-services/clients/custom-map-client'
import { PaymentsClient } from 'src/common-services/clients/payments-client'
import { SignUpClient } from 'src/common-services/clients/signup-client'
import { BillingClient } from 'src/common-services/clients/billing-client'

export function initializeClients(options: ClientOptions): Clients {
  // check type of options
  return {
    demo: new DemoClient(options),
    footfall: new FootfallClient(options),
    geo: new GeoClient(options),
    performance: new PerformanceClient(options),
    user: new UserClient(options),
    venue: new VenueClient(options),
    driveTime: new DriveTimeClient(options),
    consumerSpend: new ConsumerSpendClient(options),
    tradeArea: new TradeAreaClient(options),
    crossVisit: new CrossVisitClient(options),
    userListsClient: new UserListsClient(options),
    loggingClient: new LoggingClient(options),
    foursquareClient: new FoursquareClient(options),
    vendors: initializeVendors(options),
    system: new SystemClient(options),
    documents: new DocumentClient(options),
    mockData: new MockDataClient(options),
    traffic: new TrafficClient(options),
    dev: new DevClient(options),
    userFiles: new UserFilesClient(options),
    pricingCalculator: new PricingCalculatorClient(options),
    brandLogos: new BrandLogosClient(options),
    brands: new BrandsClient(options),
    recentlyViewed: new RecentlyViewedClient(options),
    reportThemes: new ReportThemesClient(options),
    customInsights: new CustomInsightsClient(options),
    customMaps: new CustomMapClient(options),
    customFootfall: new CustomFootfallClient(options),
    places: new PlacesClient(options),
    company: new CompanyClient(options),
    asset: new AssetClient(options),
    signup: new SignUpClient(options),
    signupRequest: new SignUpRequestClient(options),
    comps: new CompsClient(options),
    zone: new ZoneClient(options),
    localBusinesses: new LocalBusinessesClient(options),
    mobile: new MobileClient(),
    tenantFinder: new TenantFinderClient(options),
    okStatus: new OkClient(options),
    olvinClient: new OlvinClient(options),
    parcels: new ParcelsClient(options),
    alphamap: initializeAlphamap(options),
    census: new CensusClient(options),
    partners: new PartnersClient(options),
    payments: new PaymentsClient(options),
    billing: new BillingClient(options),
  }
}
